import { Component } from '@angular/core';
import { Layout } from 'app/views/presentations/layouts/layout';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';

@Component({
    selector: `psm-fullscreen-layout-component`,
    templateUrl: 'fullscreenLayout.component.html',
    styleUrls: ['../layout.component.scss']
})

export class FullscreenLayoutComponent extends LayoutComponent { }

export class FullscreenLayout extends Layout {
    public type = 'FullscreenLayout';
    public componentType = FullscreenLayoutComponent;
    public numberOfSections = 1;
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/fullscreenLayout/fullscreenLayout.component.ts